module.exports = __webpack_public_path__ + "static/media/clock.831cb945.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/StatsBox/img/clock.svg
// module id = 171
// module chunks = 0